import React from 'react';
import { cn } from './cn';

// shadcn görsel dili: nötr kenarlık + yumuşak gölge + yuvarlatılmış köşe.
export function Card({ className, children, ...props }) {
  return (
    <div
      className={cn(
        'bg-white rounded-xl border border-gray-200/80 shadow-sm',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export default Card;
